/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../teamapp/ui/models';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payroll": {
        "nested": {
          "service": {
            "nested": {
              "EmployerFundingMechanism": {
                "values": {
                  "EMPLOYER_FUNDING_MECHANISM_DO_NOT_USE": 0,
                  "ACH": 1,
                  "SQUARE_CASH": 2
                }
              },
              "PaymentService": {
                "values": {
                  "PAYMENT_SERVICE_METHOD_DO_NOT_USE": 0,
                  "TELLER_SERVICE": 1,
                  "SQUARE_CASH_SERVICE": 2
                }
              },
              "PaymentReason": {
                "values": {
                  "PAYMENT_REASON_DO_NOT_USE": 0,
                  "DEBIT_FOR_RUN": 1,
                  "SETTLEMENT_FOR_CORRECTION": 2,
                  "DEBIT_FOR_TAX": 3,
                  "TAX_PAYMENT": 4,
                  "REFUND_FOR_REVERT_TO_ANALOG": 5,
                  "MANUAL_TRANSFER": 6,
                  "MIGRATED_FROM_MONEY_MOVEMENT": 7,
                  "PAYOUT_FOR_STUB": 8,
                  "PAYOUT_FOR_CORRECTION": 9,
                  "FAILED_TRANSFER_REFUND": 10,
                  "RECOLLECT_FAILED_TRANSFER": 11,
                  "ACCELERATED_PAYOUT": 12,
                  "DEBIT_FOR_RUN_NET_PAY": 13,
                  "DEBIT_FOR_RUN_TAX": 14,
                  "LOSS_ADJUSTMENT": 15,
                  "CHURN_REFUND": 16,
                  "INSTANT_DEPOSIT": 17,
                  "SQUARE_CASH_PAYOUT_FOR_STUB": 18,
                  "DEBIT_FOR_RUN_ALICE_FEES": 19,
                  "EMPLOYER_ALICE_FEE_PAYMENT": 20,
                  "DEBIT_FOR_RUN_ALICE_DEDUCTIONS": 21,
                  "REDUCE_EMPLOYER_BALANCE": 22,
                  "FLEX_PAYCHECK": 23,
                  "FLEX_PAYCHECK_RECOLLECTION": 24,
                  "FLEX_PAYCHECK_FEE_COLLECTION": 25,
                  "BALANCE_ADJUSTMENT": 26,
                  "DEBIT_FOR_RECOLLECT_INSTANT_DEPOSIT": 27,
                  "EMPLOYER_ALICE_DEDUCTION_PAYMENT": 28,
                  "EMPLOYER_TAX_PAYMENT": 29,
                  "ESCHEATMENT": 30,
                  "FLEX_PAYCHECK_PAYOUT_REFILL": 31,
                  "REIMBURSE_RISK_LOSS": 32,
                  "SQUARE_CASH_PRE_FILL_FOR_STUBS": 33,
                  "SQUARE_CASH_REFILL_FOR_INSTANT_DEPOSIT": 34,
                  "TAX_REFUND": 35,
                  "TAX_REFUND_FOR_FAILED_DEBIT": 36,
                  "REFUND_FOR_RUN_NET_PAY": 37,
                  "FLEX_PAYCHECK_EMPLOYEE_FEE_DEBIT": 38,
                  "SUBSCRIPTION_FEE_REFUND": 39
                }
              },
              "Payment": {
                "fields": {
                  "paymentService": {
                    "type": "squareup.payroll.service.PaymentService",
                    "id": 1,
                    "rule": "optional"
                  },
                  "externalToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "squareup.payroll.service.PaymentReason",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PublicEmployee": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isEmployee": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isContractor": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "remainingSickLeaveHours": {
                    "type": "double",
                    "id": 4,
                    "rule": "optional"
                  },
                  "remainingPtoHours": {
                    "type": "double",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isMissingEmploymentInfo": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "isMissingPersonalInfo": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "isMissingTaxInfo": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "hasW2EmploymentType": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "hasContractorEmploymentType": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "needsSelfOnboarding": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  }
                }
              },
              "Employer": {
                "fields": {
                  "runTokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "fundingMechanism": {
                    "type": "squareup.payroll.service.EmployerFundingMechanism",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ein": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.payroll.service.Employer.EmployerStatus",
                    "id": 6,
                    "rule": "optional"
                  },
                  "firstW2PayDate": {
                    "type": "squareup.common.time.YearMonthDay",
                    "id": 7,
                    "rule": "optional"
                  },
                  "isPreviousPayrollValidated": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "numberOfEmployeesFeb2020": {
                    "type": "int32",
                    "id": 9,
                    "rule": "optional"
                  },
                  "hasReportingAgentAuthorization": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "EmployerStatus": {
                    "values": {
                      "EMPLOYER_STATUS_DO_NOT_USE": 0,
                      "INACTIVE": 1,
                      "ACTIVE": 2,
                      "CHURNED": 3
                    }
                  }
                }
              },
              "Run": {
                "fields": {
                  "payDate": {
                    "type": "squareup.common.time.YearMonthDay",
                    "id": 1,
                    "rule": "optional"
                  },
                  "stubTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "runToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "periodStart": {
                    "type": "squareup.common.time.YearMonthDay",
                    "id": 4,
                    "rule": "optional"
                  },
                  "periodEnd": {
                    "type": "squareup.common.time.YearMonthDay",
                    "id": 5,
                    "rule": "optional"
                  },
                  "paidOut": {
                    "type": "squareup.common.time.YearMonthDay",
                    "id": 6,
                    "rule": "optional"
                  },
                  "sentTime": {
                    "type": "squareup.common.time.DateTime",
                    "id": 7,
                    "rule": "optional"
                  },
                  "payments": {
                    "type": "squareup.payroll.service.Payment",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "squareup.payroll.service.Run.RunType",
                    "id": 10,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.payroll.service.Run.RunStatus",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "RunType": {
                    "values": {
                      "RUN_TYPE_DO_NOT_USE": 0,
                      "REGULAR": 1,
                      "OFF_CYCLE": 2,
                      "CONTRACTOR": 3
                    }
                  },
                  "RunStatus": {
                    "values": {
                      "RUN_STATUS_DO_NOT_USE": 0,
                      "EDITING": 1,
                      "PENDING": 2,
                      "COMPLETED": 3
                    }
                  }
                }
              },
              "GetEmployerStatusRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetEmployerStatusResponse": {
                "fields": {
                  "status": {
                    "type": "squareup.payroll.service.Employer.EmployerStatus",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListPublicEmployeesRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ListPublicEmployeesResponse": {
                "fields": {
                  "publicEmployee": {
                    "type": "squareup.payroll.service.PublicEmployee",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetPublicEmployeeRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetPublicEmployeeResponse": {
                "fields": {
                  "publicEmployee": {
                    "type": "squareup.payroll.service.PublicEmployee",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetW2ForFormatRequest": {
                "fields": {
                  "format": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "data": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetW2ForFormatResponse": {
                "fields": {
                  "data": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListEmployersRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ListEmployersResponse": {
                "fields": {
                  "employers": {
                    "type": "squareup.payroll.service.Employer",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetEmployeeAccessDetailsRequest": {
                "fields": {
                  "teamMemberId": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  }
                }
              },
              "GetEmployeeAccessDetailsResponse": {
                "fields": {
                  "teamMemberId": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "canAccessBenefits": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "canUseDirectDeposit": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "canUseOnDemandPay": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "requiresOnboarding": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "GetEmployeePayrollOverviewRequest": {
                "fields": {
                  "teamMemberId": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  }
                }
              },
              "GetEmployeePayrollOverviewResponse": {
                "fields": {
                  "rows": {
                    "type": "squareup.teamapp.ui.Row",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetEmployeePayrollUpsellRequest": {
                "fields": {
                  "teamMemberId": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  }
                }
              },
              "GetEmployeePayrollUpsellResponse": {
                "fields": {
                  "onDemandPay": {
                    "type": "squareup.payroll.service.EmployeePayrollUpsellForOnDemandPay",
                    "id": 1,
                    "rule": "optional"
                  },
                  "instantTransfer": {
                    "type": "squareup.payroll.service.EmployeePayrollUpsellForInstantTransfer",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "EmployeePayrollUpsellForOnDemandPay": {
                "fields": {
                  "title": {
                    "type": "squareup.teamapp.ui.ParameterizedText",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subtitle": {
                    "type": "squareup.teamapp.ui.ParameterizedText",
                    "id": 2,
                    "rule": "optional"
                  },
                  "link": {
                    "type": "squareup.teamapp.ui.Link",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "EmployeePayrollUpsellForInstantTransfer": {
                "fields": {
                  "title": {
                    "type": "squareup.teamapp.ui.ParameterizedText",
                    "id": 1,
                    "rule": "optional"
                  },
                  "title2": {
                    "type": "squareup.teamapp.ui.ParameterizedText",
                    "id": 2,
                    "rule": "optional"
                  },
                  "subtitle": {
                    "type": "squareup.teamapp.ui.ParameterizedText",
                    "id": 3,
                    "rule": "optional"
                  },
                  "subtitle2": {
                    "type": "squareup.teamapp.ui.ParameterizedText",
                    "id": 4,
                    "rule": "optional"
                  },
                  "button": {
                    "type": "squareup.teamapp.ui.Button",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ListRunsRequest": {
                "fields": {
                  "runToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ListRunsResponse": {
                "fields": {
                  "runs": {
                    "type": "squareup.payroll.service.Run",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetCompletedRunReadySetupRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  }
                }
              },
              "GetCompletedRunReadySetupResponse": {
                "fields": {
                  "completedRunReadySetup": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpdateCompletedRunReadySetupRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  }
                }
              },
              "UpdateCompletedRunReadySetupResponse": {
                "fields": {
                  "completedRunReadySetup": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetEmployerRunPayrollDetailsRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  }
                }
              },
              "GetEmployerRunPayrollDetailsResponse": {
                "fields": {
                  "completedW2Onboarding": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "completedContractorOnboarding": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sentFirstRun": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "automaticPayrollEnabled": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sentFirstW2Run": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "PublicPayrollService": {
                "methods": {
                  "GetEmployerStatus": {
                    "requestType": "squareup.payroll.service.GetEmployerStatusRequest",
                    "responseType": "squareup.payroll.service.GetEmployerStatusResponse"
                  },
                  "ListPublicEmployees": {
                    "requestType": "squareup.payroll.service.ListPublicEmployeesRequest",
                    "responseType": "squareup.payroll.service.ListPublicEmployeesResponse"
                  },
                  "GetPublicEmployee": {
                    "requestType": "squareup.payroll.service.GetPublicEmployeeRequest",
                    "responseType": "squareup.payroll.service.GetPublicEmployeeResponse"
                  },
                  "ListEmployers": {
                    "requestType": "squareup.payroll.service.ListEmployersRequest",
                    "responseType": "squareup.payroll.service.ListEmployersResponse"
                  },
                  "ListRuns": {
                    "requestType": "squareup.payroll.service.ListRunsRequest",
                    "responseType": "squareup.payroll.service.ListRunsResponse"
                  },
                  "GetW2ForFormat": {
                    "requestType": "squareup.payroll.service.GetW2ForFormatRequest",
                    "responseType": "squareup.payroll.service.GetW2ForFormatResponse"
                  },
                  "GetEmployeeAccessDetails": {
                    "requestType": "squareup.payroll.service.GetEmployeeAccessDetailsRequest",
                    "responseType": "squareup.payroll.service.GetEmployeeAccessDetailsResponse"
                  },
                  "GetEmployeePayrollOverview": {
                    "requestType": "squareup.payroll.service.GetEmployeePayrollOverviewRequest",
                    "responseType": "squareup.payroll.service.GetEmployeePayrollOverviewResponse"
                  },
                  "GetEmployeePayrollUpsell": {
                    "requestType": "squareup.payroll.service.GetEmployeePayrollUpsellRequest",
                    "responseType": "squareup.payroll.service.GetEmployeePayrollUpsellResponse"
                  },
                  "GetCompletedRunReadySetup": {
                    "requestType": "squareup.payroll.service.GetCompletedRunReadySetupRequest",
                    "responseType": "squareup.payroll.service.GetCompletedRunReadySetupResponse"
                  },
                  "UpdateCompletedRunReadySetup": {
                    "requestType": "squareup.payroll.service.UpdateCompletedRunReadySetupRequest",
                    "responseType": "squareup.payroll.service.UpdateCompletedRunReadySetupResponse"
                  },
                  "GetEmployerRunPayrollDetails": {
                    "requestType": "squareup.payroll.service.GetEmployerRunPayrollDetailsRequest",
                    "responseType": "squareup.payroll.service.GetEmployerRunPayrollDetailsResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.EmployerFundingMechanism && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.PaymentService && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.PaymentReason && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.Payment && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.PublicEmployee && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.Employer && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.Employer?.nested?.EmployerStatus && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.Run && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.Run?.nested?.RunType && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.Run?.nested?.RunStatus && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetEmployerStatusRequest && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetEmployerStatusResponse && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.ListPublicEmployeesRequest && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.ListPublicEmployeesResponse && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetPublicEmployeeRequest && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetPublicEmployeeResponse && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetW2ForFormatRequest && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetW2ForFormatResponse && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.ListEmployersRequest && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.ListEmployersResponse && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetEmployeeAccessDetailsRequest && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetEmployeeAccessDetailsResponse && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetEmployeePayrollOverviewRequest && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetEmployeePayrollOverviewResponse && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetEmployeePayrollUpsellRequest && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetEmployeePayrollUpsellResponse && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.EmployeePayrollUpsellForOnDemandPay && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.EmployeePayrollUpsellForInstantTransfer && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.ListRunsRequest && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.ListRunsResponse && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetCompletedRunReadySetupRequest && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetCompletedRunReadySetupResponse && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.UpdateCompletedRunReadySetupRequest && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.UpdateCompletedRunReadySetupResponse && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetEmployerRunPayrollDetailsRequest && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.GetEmployerRunPayrollDetailsResponse && !$root.nested?.squareup?.nested?.payroll?.nested?.service?.nested?.PublicPayrollService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE EmployerFundingMechanism @ squareup/payroll/service.proto at 20:1
 */
export const EmployerFundingMechanism = $root.lookupEnum('squareup.payroll.service.EmployerFundingMechanism').values;
/**
 * SOURCE PaymentService @ squareup/payroll/service.proto at 38:1
 */
export const PaymentService = $root.lookupEnum('squareup.payroll.service.PaymentService').values;
/**
 * SOURCE PaymentReason @ squareup/payroll/service.proto at 44:1
 */
export const PaymentReason = $root.lookupEnum('squareup.payroll.service.PaymentReason').values;
/**
 * SOURCE Payment @ squareup/payroll/service.proto at 95:1
 */
export const Payment = $root.lookupType('squareup.payroll.service.Payment');
fixType(Payment);
Builder.createAndAttachToType(Payment);
/**
 * SOURCE PublicEmployee @ squareup/payroll/service.proto at 105:1
 */
export const PublicEmployee = $root.lookupType('squareup.payroll.service.PublicEmployee');
fixType(PublicEmployee);
Builder.createAndAttachToType(PublicEmployee);
/**
 * SOURCE Employer @ squareup/payroll/service.proto at 125:1
 */
export const Employer = $root.lookupType('squareup.payroll.service.Employer');
fixType(Employer);
Builder.createAndAttachToType(Employer);
/**
 * SOURCE EmployerStatus @ squareup/payroll/service.proto at 126:3
 */
Employer.EmployerStatus = $root.lookupEnum('squareup.payroll.service.Employer.EmployerStatus').values;
/**
 * SOURCE Run @ squareup/payroll/service.proto at 195:1
 */
export const Run = $root.lookupType('squareup.payroll.service.Run');
fixType(Run);
Builder.createAndAttachToType(Run);
/**
 * SOURCE RunType @ squareup/payroll/service.proto at 196:3
 */
Run.RunType = $root.lookupEnum('squareup.payroll.service.Run.RunType').values;
/**
 * SOURCE RunStatus @ squareup/payroll/service.proto at 203:3
 */
Run.RunStatus = $root.lookupEnum('squareup.payroll.service.Run.RunStatus').values;
/**
 * SOURCE GetEmployerStatusRequest @ squareup/payroll/service.proto at 244:1
 */
export const GetEmployerStatusRequest = $root.lookupType('squareup.payroll.service.GetEmployerStatusRequest');
fixType(GetEmployerStatusRequest);
Builder.createAndAttachToType(GetEmployerStatusRequest);
/**
 * SOURCE GetEmployerStatusResponse @ squareup/payroll/service.proto at 248:1
 */
export const GetEmployerStatusResponse = $root.lookupType('squareup.payroll.service.GetEmployerStatusResponse');
fixType(GetEmployerStatusResponse);
Builder.createAndAttachToType(GetEmployerStatusResponse);
/**
 * SOURCE ListPublicEmployeesRequest @ squareup/payroll/service.proto at 252:1
 */
export const ListPublicEmployeesRequest = $root.lookupType('squareup.payroll.service.ListPublicEmployeesRequest');
fixType(ListPublicEmployeesRequest);
Builder.createAndAttachToType(ListPublicEmployeesRequest);
/**
 * SOURCE ListPublicEmployeesResponse @ squareup/payroll/service.proto at 256:1
 */
export const ListPublicEmployeesResponse = $root.lookupType('squareup.payroll.service.ListPublicEmployeesResponse');
fixType(ListPublicEmployeesResponse);
Builder.createAndAttachToType(ListPublicEmployeesResponse);
/**
 * SOURCE GetPublicEmployeeRequest @ squareup/payroll/service.proto at 260:1
 */
export const GetPublicEmployeeRequest = $root.lookupType('squareup.payroll.service.GetPublicEmployeeRequest');
fixType(GetPublicEmployeeRequest);
Builder.createAndAttachToType(GetPublicEmployeeRequest);
/**
 * SOURCE GetPublicEmployeeResponse @ squareup/payroll/service.proto at 264:1
 */
export const GetPublicEmployeeResponse = $root.lookupType('squareup.payroll.service.GetPublicEmployeeResponse');
fixType(GetPublicEmployeeResponse);
Builder.createAndAttachToType(GetPublicEmployeeResponse);
/**
 * SOURCE GetW2ForFormatRequest @ squareup/payroll/service.proto at 305:1
 */
export const GetW2ForFormatRequest = $root.lookupType('squareup.payroll.service.GetW2ForFormatRequest');
fixType(GetW2ForFormatRequest);
Builder.createAndAttachToType(GetW2ForFormatRequest);
/**
 * SOURCE GetW2ForFormatResponse @ squareup/payroll/service.proto at 310:1
 */
export const GetW2ForFormatResponse = $root.lookupType('squareup.payroll.service.GetW2ForFormatResponse');
fixType(GetW2ForFormatResponse);
Builder.createAndAttachToType(GetW2ForFormatResponse);
/**
 * SOURCE ListEmployersRequest @ squareup/payroll/service.proto at 388:1
 */
export const ListEmployersRequest = $root.lookupType('squareup.payroll.service.ListEmployersRequest');
fixType(ListEmployersRequest);
Builder.createAndAttachToType(ListEmployersRequest);
/**
 * SOURCE ListEmployersResponse @ squareup/payroll/service.proto at 392:1
 */
export const ListEmployersResponse = $root.lookupType('squareup.payroll.service.ListEmployersResponse');
fixType(ListEmployersResponse);
Builder.createAndAttachToType(ListEmployersResponse);
/**
 * SOURCE GetEmployeeAccessDetailsRequest @ squareup/payroll/service.proto at 418:1
 */
export const GetEmployeeAccessDetailsRequest = $root.lookupType('squareup.payroll.service.GetEmployeeAccessDetailsRequest');
fixType(GetEmployeeAccessDetailsRequest);
Builder.createAndAttachToType(GetEmployeeAccessDetailsRequest);
/**
 * SOURCE GetEmployeeAccessDetailsResponse @ squareup/payroll/service.proto at 422:1
 */
export const GetEmployeeAccessDetailsResponse = $root.lookupType('squareup.payroll.service.GetEmployeeAccessDetailsResponse');
fixType(GetEmployeeAccessDetailsResponse);
Builder.createAndAttachToType(GetEmployeeAccessDetailsResponse);
/**
 * SOURCE GetEmployeePayrollOverviewRequest @ squareup/payroll/service.proto at 431:1
 */
export const GetEmployeePayrollOverviewRequest = $root.lookupType('squareup.payroll.service.GetEmployeePayrollOverviewRequest');
fixType(GetEmployeePayrollOverviewRequest);
Builder.createAndAttachToType(GetEmployeePayrollOverviewRequest);
/**
 * SOURCE GetEmployeePayrollOverviewResponse @ squareup/payroll/service.proto at 435:1
 */
export const GetEmployeePayrollOverviewResponse = $root.lookupType('squareup.payroll.service.GetEmployeePayrollOverviewResponse');
fixType(GetEmployeePayrollOverviewResponse);
Builder.createAndAttachToType(GetEmployeePayrollOverviewResponse);
/**
 * SOURCE GetEmployeePayrollUpsellRequest @ squareup/payroll/service.proto at 439:1
 */
export const GetEmployeePayrollUpsellRequest = $root.lookupType('squareup.payroll.service.GetEmployeePayrollUpsellRequest');
fixType(GetEmployeePayrollUpsellRequest);
Builder.createAndAttachToType(GetEmployeePayrollUpsellRequest);
/**
 * SOURCE GetEmployeePayrollUpsellResponse @ squareup/payroll/service.proto at 443:1
 */
export const GetEmployeePayrollUpsellResponse = $root.lookupType('squareup.payroll.service.GetEmployeePayrollUpsellResponse');
fixType(GetEmployeePayrollUpsellResponse);
Builder.createAndAttachToType(GetEmployeePayrollUpsellResponse);
/**
 * SOURCE EmployeePayrollUpsellForOnDemandPay @ squareup/payroll/service.proto at 448:1
 */
export const EmployeePayrollUpsellForOnDemandPay = $root.lookupType('squareup.payroll.service.EmployeePayrollUpsellForOnDemandPay');
fixType(EmployeePayrollUpsellForOnDemandPay);
Builder.createAndAttachToType(EmployeePayrollUpsellForOnDemandPay);
/**
 * SOURCE EmployeePayrollUpsellForInstantTransfer @ squareup/payroll/service.proto at 454:1
 */
export const EmployeePayrollUpsellForInstantTransfer = $root.lookupType('squareup.payroll.service.EmployeePayrollUpsellForInstantTransfer');
fixType(EmployeePayrollUpsellForInstantTransfer);
Builder.createAndAttachToType(EmployeePayrollUpsellForInstantTransfer);
/**
 * SOURCE ListRunsRequest @ squareup/payroll/service.proto at 462:1
 */
export const ListRunsRequest = $root.lookupType('squareup.payroll.service.ListRunsRequest');
fixType(ListRunsRequest);
Builder.createAndAttachToType(ListRunsRequest);
/**
 * SOURCE ListRunsResponse @ squareup/payroll/service.proto at 466:1
 */
export const ListRunsResponse = $root.lookupType('squareup.payroll.service.ListRunsResponse');
fixType(ListRunsResponse);
Builder.createAndAttachToType(ListRunsResponse);
/**
 * * Returns whether or not the employer has completed their
 * * run-ready onboarding tasks and has previously been notified
 * * that they are run-ready.
 *
 * SOURCE GetCompletedRunReadySetupRequest @ squareup/payroll/service.proto at 535:1
 */
export const GetCompletedRunReadySetupRequest = $root.lookupType('squareup.payroll.service.GetCompletedRunReadySetupRequest');
fixType(GetCompletedRunReadySetupRequest);
Builder.createAndAttachToType(GetCompletedRunReadySetupRequest);
/**
 * SOURCE GetCompletedRunReadySetupResponse @ squareup/payroll/service.proto at 539:1
 */
export const GetCompletedRunReadySetupResponse = $root.lookupType('squareup.payroll.service.GetCompletedRunReadySetupResponse');
fixType(GetCompletedRunReadySetupResponse);
Builder.createAndAttachToType(GetCompletedRunReadySetupResponse);
/**
 * * For updating the state of an employer after the first time
 * * they've been notified that they are run-ready after completing
 * * the requisite setup tasks.
 *
 * SOURCE UpdateCompletedRunReadySetupRequest @ squareup/payroll/service.proto at 548:1
 */
export const UpdateCompletedRunReadySetupRequest = $root.lookupType('squareup.payroll.service.UpdateCompletedRunReadySetupRequest');
fixType(UpdateCompletedRunReadySetupRequest);
Builder.createAndAttachToType(UpdateCompletedRunReadySetupRequest);
/**
 * SOURCE UpdateCompletedRunReadySetupResponse @ squareup/payroll/service.proto at 552:1
 */
export const UpdateCompletedRunReadySetupResponse = $root.lookupType('squareup.payroll.service.UpdateCompletedRunReadySetupResponse');
fixType(UpdateCompletedRunReadySetupResponse);
Builder.createAndAttachToType(UpdateCompletedRunReadySetupResponse);
/**
 * SOURCE GetEmployerRunPayrollDetailsRequest @ squareup/payroll/service.proto at 556:1
 */
export const GetEmployerRunPayrollDetailsRequest = $root.lookupType('squareup.payroll.service.GetEmployerRunPayrollDetailsRequest');
fixType(GetEmployerRunPayrollDetailsRequest);
Builder.createAndAttachToType(GetEmployerRunPayrollDetailsRequest);
/**
 * SOURCE GetEmployerRunPayrollDetailsResponse @ squareup/payroll/service.proto at 560:1
 */
export const GetEmployerRunPayrollDetailsResponse = $root.lookupType('squareup.payroll.service.GetEmployerRunPayrollDetailsResponse');
fixType(GetEmployerRunPayrollDetailsResponse);
Builder.createAndAttachToType(GetEmployerRunPayrollDetailsResponse);
/**
 * SOURCE PublicPayrollService @ squareup/payroll/service.proto at 604:1
 */
export const PublicPayrollService = $root.lookupService('squareup.payroll.service.PublicPayrollService');